<div #bomCopyModal class="modal fade" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md modal-copy">
    <div class="modal-content no-border border-radius-0">
      <div class="modal-header text-uppercase font-size-16">
        <div class="modal-title">
          <ng-container i18n="@@app.bom_copy_header">Copy to?</ng-container>
        </div>
        <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body mx-3 my-2 px-0">
        <div class="">
          <app-bom-copy-modal-content [selectedOption]="selectedOption" (optionSelected)="selectOption($event)">
            <div class="row text-center bg-dark-gray rounded-pill py-1 px-2 align-items-center mx-2 arrow_box d-inline-flex mb-2">
              <div class="d-flex pr-1">
                <i class="cursor-pointer pb-1 px-1">
                  <img src="/assets/images/info_icon.png" alt="info" width="15">
                </i>
              </div>
              <div class="col-sm-11 p-0 m-0 pb-1 font-size-10 font-weight-bolder text-left">
                <b class="font-weight-900 mr-1">DispoSuite:</b>
                @if (selectedOption === 0) {
                  <span>
                    <ng-container i18n="@@app_copy_headerInfo_option0">Suite will copy only "E-No." and "Quantity" columns from the table!</ng-container>
                  </span>
                }
                @if (selectedOption === 3) {
                  <span>
                    <ng-container i18n="@@app_direct_transfer_info_description">All positions are directly transferred to the wholesaler via the ELBRIDGE interface.</ng-container>
                  </span>
                }
                @if (selectedOption === 1) {
                  <span>
                    <ng-container i18n="@@app_copy_headerInfo_option1">Suite will download only "E-No." and "Quantity" columns from the table!</ng-container>
                  </span>
                }
                @if (selectedOption === 2) {
                  <span>
                    <ng-container i18n="@@app_copy_headerInfo_option2">Suite will copy only "Reference-No." and "Quantity" columns from the table!</ng-container>
                  </span>
                }
              </div>
            </div>
          </app-bom-copy-modal-content>
        </div>
      </div>

      <div class="modal-footer pt-0 no-border">
        <button type="button" (click)="closeModal()"
          class="btn btn-light btn-lg text-uppercase border-rounded font-weight-normal mx-2"
        i18n="@@app.cancel">Cancel</button>
        <button appDisableMultipleClick
          type="button"
          class="btn btn-primary btn-lg text-uppercase border-rounded mx-2 font-weight-normal"
        (click)="onConfirm()" i18n="@@app.ok">Ok</button>
      </div>
    </div>
  </div>
  <app-document-types
    #BOMDescription
    [isHidden]="true"
    [property]="'bom'"
  ></app-document-types>
</div>
